import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useNlpIntegrationGetLiveTopicsStationSettings } from '@mi-front/api-v2';

/**
 * Returns whether the live topics feature is enabled for the current (active) station.
 * Uses the station settings API; when loading or on error, returns false.
 */
export function useLiveTopicsEnabledForStation(): boolean {
  const station = useActiveStation();
  const { data, isSuccess } = useNlpIntegrationGetLiveTopicsStationSettings(station.id);

  if (!isSuccess || !data?.settings) {
    return false;
  }

  return data.settings.enabled === true;
}
